<template>
  <div class="app-container crm-detail business-detail">
    <el-card class="crm-detail-base" shadow="never">
      <el-row>
        <el-col :span="16">
          <span class="base-name">{{detail.businessName}}</span>
        </el-col>
        <el-col :span="8" v-if="detail.id" align="right">
          <el-button
            v-if="detail.changeStatus === 1"
            type="primary"
            plain
            size="mini"
            icon="el-icon-finished"
            @click="handleBusinessApprove"
          >审批流程</el-button>
          <el-button type="text" v-if="!detail.focusFlag" @click="handleFocus(1)">关注</el-button>
          <el-button type="text" v-if="detail.focusFlag" @click="handleFocus(2)">取消关注</el-button>
          <!--商机状态 0-转化中 1-输单 2-已成交 3-无效 4-挂起-->
          <el-button type="text" v-if="detail.canAssignFlag" @click="handleAssign()">分配</el-button>
          <el-button type="text" v-if="detail.canChangeFlag" @click="handleChange()">变更</el-button>
        </el-col>
      </el-row>
      <div>
        <div class="base-item">
          <div class="title label">客户名称</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail()">{{detail.customerName}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">商机编号</div>
          <div class="value">{{detail.businessNum}}</div>
        </div>
        <div class="base-item">
          <div class="title label">商机级别</div>
          <div class="value">{{detail.businessLevelDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">商机状态</div>
          <div class="value">{{detail.businessStatusDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">商机阶段</div>
          <div class="value">{{detail.currentStageDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">预计成交金额(元)</div>
          <div class="value">{{ (detail.estimateDealAmount || 0 )/ 10000}} 万元</div>
        </div>
        <div class="base-item">
          <div class="title label">预计成交时间</div>
          <div class="value">{{detail.estimateDealDate}}</div>
        </div>
        <div class="base-item">
          <div class="title label">签约金额(元)</div>
          <div class="value">{{ (detail.signAmount || 0) / 10000}} 万元</div>
        </div>
        <div class="base-item">
          <div class="title label">签约日期</div>
          <div class="value">{{detail.realDealDate}}</div>
        </div>
        <div class="base-item">
          <div class="title label">转化天数</div>
          <div class="value">{{detail.turnDays || detail.turnDays===0 ? detail.turnDays + "天" : ""}}</div>
        </div>
      </div>
    </el-card>
    <BusinessChangedStage
      ref="businessChangedStageRef"
      :detail="detail"
      @success="refreshDetailAndLog"
      v-if="detail.changeStatus === 1"
    ></BusinessChangedStage>
    <el-card v-else class="crm-detail-business-stage" shadow="never">
      <!-- 商机阶段 changeStatus 变更状态 0-无 1-变更中 2-变更完成 3-变更驳回 4-变更取消-->
      <BusinessChangedStage :detail="detail" @success="refreshDetailAndLog" v-if="detail.changeStatus === 2"></BusinessChangedStage>
      <business-stage :detail="detail" ref="businessStageRef" @stage-change="businessStageChange" v-else></business-stage>
      <!-- 商机变更后展示 -->
    </el-card>
    <el-row :gutter="16">
      <el-col :span="16">
        <el-card class="crm-detail-main" v-if="detail.id" shadow="never">
          <el-tabs v-model="activeName" @tab-click="handleTabClick" :stretch="true">
            <el-tab-pane label="跟进计划" name="followPlan">
              <el-tabs v-model="followPlanActiveName" :stretch="true">
                <el-tab-pane label="跟进记录" name="follow">
                  <FollowAdd ref="followAddRef"  :targetId="detail.id" targetType="business" :businessStageCode="detail.currentStageCode"
                             @success="handleAfterFollowAdd"></FollowAdd>
                  <div style="height: 473px">
                    <FollowList :targetId="detail.id" targetType="business" ref="followListRef"></FollowList>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="工作计划" name="workPlan">
                  <WorkPlan ref="workPlanRef" :targetId="detail.id" targetType="business" :managerId="detail.managerId" @success="handleAfterWorkPlanAdd"></WorkPlan>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="详细资料" name="detail">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="text" @click="handleEdit" v-if="!editModel && !detail.relatedReadOnly" :disabled="!detail.id">编辑资料</el-button>
                  <el-button type="primary" @click="handleEditSave" v-if="editModel">保存</el-button>
                  <el-button  @click="editModel=false" v-if="editModel">取消</el-button>
                </el-col>
              </el-row>
              <el-form :model="updateData" :rules="updateRules" ref="updateForm" label-width="135px" :hide-required-asterisk="!editModel">
                <el-card shadow="never" class="el-card-simple">
                  <div slot="header">
                    <span>商机信息</span>
                  </div>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="商机编号:" prop="businessNum">
                        <span class="value">{{detail.businessNum}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="商机名称:" prop="businessName">
                        <el-input v-if="editModel" v-model="updateData.businessName" :maxlength="32" placeholder="请输入商机名称" clearable/>
                        <span v-else class="value">{{detail.businessName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="商机级别:" prop="businessLevel">
                        <el-select v-if="editModel" v-model="updateData.businessLevel" placeholder="请选择商机级别" clearable style="width:100%">
                          <el-option v-for="dict in businessLevelOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                        <span v-else class="value" style="margin-right: 10px" >{{detail.businessLevelDesc}}</span>
                        <el-popover placement="right" title="商机级别" width="410" trigger="hover">
                          <div>
                            A类商机：需满足3个条件，搞定人、搞定事、1个月内签约。<br>
                            B类商机：需满足3个条件，搞定人、搞定事、2个月内签约。<br>
                            C类商机：人和事都没搞定。<br>
                            D类商机：商机项目待定，且人和事看未搞定。
                          </div>
                          <el-button slot="reference" type="text">商机级别说明</el-button>
                        </el-popover>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="商机规模:" prop="businessScale">
                        <el-select v-if="editModel" v-model="updateData.businessScale" placeholder="请选择商机规模" clearable style="width:100%">
                          <el-option v-for="dict in businessScaleOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                        <span v-else class="value" style="margin-right: 10px" >{{detail.businessScaleDesc}}</span>
                        <el-popover placement="right" title="商机规模（金额）" width="200" trigger="hover">
                          <div>
                            甲：300万及以上<br>
                            乙：100万-300万<br>
                            丙：50万-100万<br>
                            丁：50万以下
                          </div>
                          <el-button slot="reference" type="text">商机规模说明</el-button>
                        </el-popover>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="商机来源:" prop="businessSource">
                        <el-select v-if="editModel" v-model="updateData.businessSource" placeholder="请选择商机来源" allow-create filterable clearable style="width:100%">
                          <el-option v-for="dict in businessSourceOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                        <span v-else class="value" style="margin-right: 10px" >{{detail.businessSourceDesc}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="来源客户:" prop="businessSourceCustomerId">
                        <customer-select v-if="editModel" ref="customerSelectRef" :form-param="updateData" :param-list="sourceCustomerList"
                                         :field-name="'businessSourceCustomerId'" @change="businessSourceCustomerChange"></customer-select>
                        <el-button v-else type="text" @click="skipCustomerDetail(detail.businessSourceCustomerId)">{{detail.businessSourceCustomerName}}</el-button>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="来源联系人:" prop="businessSourceContactId">
                        <el-select v-if="editModel" v-model="updateData.businessSourceContactId" placeholder="请选择来源联系人" clearable style="width:100%">
                          <el-option v-for="dict in businessSourceContactList" :key="dict.id" :label="dict.name" :value="dict.id"/>
                        </el-select>
                        <el-button v-else type="text" @click="skipContactDetail(detail.businessSourceContactId)">{{detail.businessSourceContactName}}</el-button>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                      <el-form-item label="创建人:">
                        <span class="value">{{detail.createByName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="创建时间:" v-if="!editModel">
                        <span class="value">{{detail.createTime}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-form-item label="备注:" prop="remark">
                        <el-input
                          v-if="editModel"
                          type="textarea"
                          :autosize="{ minRows: 3, maxRows: 5}"
                          :maxlength="1000"
                          show-word-limit
                          v-model="updateData.remark"
                          placeholder="请输入备注"
                          clearable/>
                        <span v-else class="value">{{detail.remark}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <el-card shadow="never" class="el-card-simple">
                  <div slot="header">
                    <span>项目信息</span>
                  </div>
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="客户名称:" prop="customerId">
                        <span class="value" @click="skipCustomerDetail(detail.customerId)">{{detail.customerName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="采购需求:" prop="requirements">
                        <el-select v-if="editModel" v-model="updateData.requirements" placeholder="请选择采购需求" multiple clearable style="width:100%">
                          <el-option v-for="dict in requirementOptions" :key="dict.value" :label="dict.label" :value="dict.value"/>
                        </el-select>
                        <span v-else class="value">{{detail.requirementsDesc}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="项目类型:" prop="projectType">
                        <el-select v-if="editModel" v-model="updateData.projectType" placeholder="请选择项目类型" clearable style="width:100%">
                          <el-option v-for="dict in projectTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                        <span v-else class="value" style="margin-right: 10px" >{{detail.projectTypeDesc}}</span>
                        <el-popover v-if="updateData.projectType==1 || detail.projectType==1"
                                    placement="right" title="难降解工业废水类别说明" width="400" trigger="hover">
                          <span>医疗废水；制药废水；化工废水；垃圾渗滤液；印染废水；实验室废水；食品废水；养殖废水；屠宰废水；餐厨废水；饮料废水；电子废水；光伏废水；乳液废水</span>
                          <el-button v-if="updateData.projectType==1 || detail.projectType==1" slot="reference" type="text">难降解工业废水类别说明
                          </el-button>
                        </el-popover>
                      </el-form-item>
                    </el-col>
<!--                    <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">-->
<!--                      <el-form-item label="项目区域:">-->
<!--                        <span class="value">{{detail.provinceName}}{{detail.cityName}}{{detail.regionName}}</span>-->
<!--                      </el-form-item>-->
<!--                    </el-col>-->
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="项目区域:" prop="area">
                        <el-cascader v-if="editModel" v-model="updateData.area" :options="areaOptions" :props="{ checkStrictly: true }" filterable clearable style="width:100%"></el-cascader>
                        <span v-else class="value">{{detail.provinceName}}{{detail.cityName}}{{detail.regionName}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="详细地址:" prop="address">
                        <el-input v-if="editModel" v-model="updateData.address" :maxlength="64" placeholder="请输入详细地址" clearable/>
                        <span v-else class="value">{{detail.address}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="业主名称:" prop="projectOwnerCustomerId">
                        <customer-select v-if="editModel" ref="yzCustomerSelectRef" :form-param="updateData"
                                         :field-name="'projectOwnerCustomerId'" :param-list="yzCustomerList"></customer-select>
                        <el-button v-else type="text" @click="skipCustomerDetail(detail.projectOwnerCustomerId)">{{detail.projectOwnerCustomerName}}</el-button>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="预计成交金额:" prop="estimateDealAmount">
                        <el-input-number v-if="editModel" v-model="updateData.estimateDealAmount" placeholder="请输入预计成交金额" :min="0" :max="999999999" :precision="2" :controls="false" clearable class="crm-input-number-wrap"/>
                        <span v-if="editModel" class="el-input__suffix">元</span>
                        <span v-if="!editModel" class="value">{{amountFormat(detail.estimateDealAmount)}}元</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="预计成交时间:" prop="estimateDealDate">
                        <el-date-picker v-if="editModel" v-model="updateData.estimateDealDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
                        <span v-else class="value">{{detail.estimateDealDate}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
              </el-form>
            </el-tab-pane>
            <el-tab-pane :label="'联系人(' + contactCount + ')'" name="contact">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="primary" @click="handleAddBusinessContact" >新增商机联系人</el-button>
                </el-col>
              </el-row>
              <BusinessContactList
                ref="businessContactListRef"
                :businessId="detail.id"
                :customer-id="detail.customerId"
                height="630"
                @after-query="handleAfterContactQuery"
                @after-change="handleAfterContactChange">
              </BusinessContactList>
            </el-tab-pane>
            <el-tab-pane label="SWOT分析" name="swot">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="text" @click="handleSwotEdit"  v-if="!editSwotModel">编辑</el-button>
                  <el-button type="primary" @click="handleSwotEditSave" v-if="editSwotModel">保存</el-button>
                  <el-button  @click="editSwotModel=false" v-if="editSwotModel">取消</el-button>
                </el-col>
              </el-row>
              <el-form :model="updateSwotData" :rules="updateSwotRules" ref="updateSwotForm" label-width="85px" :hide-required-asterisk="!editSwotModel">
                <el-row :gutter="20" align="left">
                  <el-col>
                    <el-form-item label="优势:" prop="strengths">
                      <el-input
                        v-if="editSwotModel"
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 5}"
                        :maxlength="1000"
                        show-word-limit
                        v-model="updateSwotData.strengths"
                        placeholder="请输入优势"
                        clearable/>
                      <span v-else class="value">{{swot.strengths}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="劣势:" prop="weaknesses">
                      <el-input
                        v-if="editSwotModel"
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 5}"
                        :maxlength="1000"
                        show-word-limit
                        v-model="updateSwotData.weaknesses"
                        placeholder="请输入劣势"
                        clearable/>
                      <span v-else class="value">{{swot.weaknesses}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="机遇:" prop="opportunities">
                      <el-input
                        v-if="editSwotModel"
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 5}"
                        :maxlength="1000"
                        show-word-limit
                        v-model="updateSwotData.opportunities"
                        placeholder="请输入机遇"
                        clearable/>
                      <span v-else class="value">{{swot.opportunities}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="挑战:" prop="threats">
                      <el-input
                        v-if="editSwotModel"
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 5}"
                        :maxlength="1000"
                        show-word-limit
                        v-model="updateSwotData.threats"
                        placeholder="请输入挑战"
                        clearable/>
                      <span v-else class="value">{{swot.threats}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="竞争对手" name="competitor">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="primary" @click="handleAddBusinessCompetitor" >新增竞争对手</el-button>
                </el-col>
              </el-row>
              <BusinessCompetitorList
                ref="businessCompetitorListRef"
                :businessId="detail.id"
                height="630"
                @after-change="handleAfterContactChange">
              </BusinessCompetitorList>
            </el-tab-pane>
            <el-tab-pane label="方案" name="plan">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="primary" @click="handleAddBusinessPlan" >新增方案</el-button>
                </el-col>
              </el-row>
              <BusinessPlanList
                ref="businessPlanListRef"
                :businessId="detail.id"
                height="630"
                @after-change="handleAfterContactChange">
              </BusinessPlanList>
            </el-tab-pane>
            <el-tab-pane :label="'合同(' + contractCount + ')'" name="contract">
              <el-row v-if="detail.id">
                <el-col align="right" style="height: 40px;">
                  <el-button v-hasPermi="['crm:quote:save']" type="primary" plain @click="handleAddBusinessQuote">报价测算</el-button>
                  <el-button v-if="detail.canAddContractFlag" type="primary" @click="handleAddBusinessContract" >新增合同</el-button>
                </el-col>
              </el-row>
              <div v-if="detail.id" class="business-quote-records">
                <div class="quote-records-header">
                  <span class="quote-records-title">报价测算记录（{{ quoteCount }}）</span>
                  <el-button type="text" icon="el-icon-refresh" @click="queryBusinessQuoteList">刷新</el-button>
                </div>
                <el-table v-loading="quoteLoading" :data="quoteList" size="mini" height="220" @row-dblclick="handleViewBusinessQuote">
                  <el-table-column label="报价编号" width="230" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span class="business-quote-no-cell">
                        <el-link
                          type="primary"
                          class="business-quote-no-link"
                          :underline="false"
                          :title="scope.row.quoteNo || '-'"
                          @click="handleViewBusinessQuote(scope.row)"
                        >{{ scope.row.quoteNo || '-' }}</el-link>
                        <el-button
                          v-if="scope.row.quoteNo"
                          type="text"
                          icon="el-icon-document-copy"
                          title="复制报价编号"
                          @click.stop="copyText(scope.row.quoteNo, '报价编号')"
                        />
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="报价名称" prop="quoteName" min-width="150" show-overflow-tooltip />
                  <el-table-column label="报价金额" width="110" align="right">
                    <template slot-scope="scope">{{ quoteMoney(scope.row.totalAmount) }}</template>
                  </el-table-column>
                  <el-table-column label="预计成本" width="110" align="right">
                    <template slot-scope="scope">{{ quoteMoney(scope.row.costAmount) }}</template>
                  </el-table-column>
                  <el-table-column label="毛利率" width="80" align="right">
                    <template slot-scope="scope">{{ quoteNumberText(scope.row.grossMargin) }}%</template>
                  </el-table-column>
                  <el-table-column label="风险" width="110" align="center">
                    <template slot-scope="scope">
                      <el-tag v-if="Number(scope.row.riskFlag) === 1" type="danger" size="mini">{{ quoteRiskText(scope.row.riskSummary) }}</el-tag>
                      <el-tag v-else size="mini">无风险</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="状态" width="90" align="center">
                    <template slot-scope="scope">
                      <el-tag :type="quoteStatusTag(scope.row.status)" size="mini">{{ quoteStatusText(scope.row.status) }}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="用章审批" width="100" align="center">
                    <template slot-scope="scope">
                      <el-tag :type="quoteSealStatusTag(scope.row.sealStatus)" size="mini">{{ quoteSealStatusText(scope.row.sealStatus) }}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="更新时间" prop="updateTime" width="145" align="center" />
                  <el-table-column label="操作" width="310" fixed="right" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" @click="handleViewBusinessQuote(scope.row)">查看</el-button>
                      <el-button type="text" @click="handleBusinessQuoteSheet(scope.row)">报价单</el-button>
                      <el-button type="text" @click="handleBusinessQuoteContractDraft(scope.row)">合同草稿</el-button>
                      <el-button v-if="canSubmitBusinessQuoteSealApproval(scope.row)" v-hasPermi="['crm:quote:sealApproval']" type="text" @click="handleBusinessQuoteSealApproval(scope.row)">发起用章</el-button>
                      <el-button v-if="scope.row.sealWorkOrderId" v-hasPermi="['crm:quote:approvalRecord']" type="text" @click="handleBusinessQuoteApprovalRecord(scope.row)">审批进度</el-button>
                      <el-button v-hasPermi="['crm:quote:convertContract']" type="text" @click="handleBusinessQuoteContract(scope.row)">{{ scope.row.contractId ? '查看合同' : '生成合同' }}</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <el-divider content-position="left">合同记录</el-divider>
              <ContractList v-if="detail.id" ref="contractListRef" :businessId="detail.id" @after-query="handleAfterContractQuery">
              </ContractList>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="crm-detail-follow" v-if="detail.id" shadow="never">
          <div class="label">负责人</div>
          <div class="crm-manager">
            <UserAvatar class="avatar" :url="detail.managerAvatar" :name="detail.managerName"/>
            <div class="name"><span class="value">{{detail.managerName}}</span></div>
          </div>
          <GroupMember :groupName="'商机团队'" :targetId="detail.id" :targetType="'business'"
                       :canAddGroupMemberFlag="detail.canAddGroupMemberFlag" @success="handleGroupMemberSuccess"/>
          <el-divider content-position="left"><span class="label">操作日志</span></el-divider>
          <div style="height: 534px">
            <OperateLogList ref="operateLogListRef" :targetId="detail.id" targetType="business"></OperateLogList>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <AssignDialog ref="assignDialogRef" @success="refreshDetailAndLog"></AssignDialog>
<!--    <el-dialog title="关闭商机" :visible.sync="closeBusinessVisible" width="550px" :close-on-click-modal="false">-->
<!--      <el-form :model="closeBusinessModel" :rules="closeBusinessFormRules" ref="closeBusinessForm" label-width="100px">-->
<!--        <el-form-item label="关闭原因：" prop="closeReason">-->
<!--          <el-select v-model="closeBusinessModel.closeReason" placeholder="请选择关闭原因" clearable style="width:100%">-->
<!--            <el-option v-for="item in closeReasonOptions" :key="item.name" :label="item.name" :value="item.name"/>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="关闭说明：" prop="closeDesc">-->
<!--          <el-input type="textarea" v-model="closeBusinessModel.closeDesc" :autosize="{ minRows: 3}"-->
<!--                    :maxlength="1000" placeholder="请输入1000字以内" show-word-limit/>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
<!--      <span slot="footer" class="dialog-footer">-->
<!--            <el-button @click="closeBusinessVisible = false">取消</el-button>-->
<!--            <el-button type="primary" @click="confirmClose">确认</el-button>-->
<!--      </span>-->
<!--    </el-dialog>-->
    <el-dialog title="关闭原因" :visible.sync="closeReasonVisible" width="550px">
      <div style="margin-left: 20px">
        <div>关闭原因：{{detail.closeReason}}</div>
        <div style="margin-top: 20px">关闭说明：{{detail.closeDesc}}</div>
      </div>
    </el-dialog>

    <AddBusinessContactDialog ref="addBusinessContactDialogRef" @success="refreshContactAndLog"></AddBusinessContactDialog>
    <AddBusinessCompetitorDialog ref="addBusinessCompetitorDialogRef" @success="refreshCompetitorAndLog"></AddBusinessCompetitorDialog>
    <AddBusinessPlanDialog ref="addBusinessPlanDialogRef" @success="refreshPlanAndLog"></AddBusinessPlanDialog>
    <AddContractDialog ref="addContractDialogRef" @success="refreshContractAndLog"></AddContractDialog>
    <QuoteCalculation ref="quoteCalculationRef" embedded @saved="refreshQuoteAndLog"></QuoteCalculation>
    <!-- 变更 -->
    <BusinessStageChangeDialog ref="businessStageChange" @success="refreshDetailMemberAndLog"></BusinessStageChangeDialog>
  </div>
</template>

<script>
import FollowList from "@/views/crm/follow/followList";
import FollowAdd from "@/views/crm/follow/followAdd";
import WorkPlan from "@/views/crm/workPlan/workPlan";
import OperateLogList from "@/views/crm/components/operateLogList";
import AssignDialog from "@/views/crm/components/assignDialog";
import AddBusinessContactDialog from "@/views/crm/business/addBusinessContactDialog";
import AddBusinessCompetitorDialog from "@/views/crm/business/addBusinessCompetitorDialog";
import AddBusinessPlanDialog from "@/views/crm/business/addBusinessPlanDialog";
import BusinessContactList from "@/views/crm/business/businessContactList";
import AddContractDialog from "@/views/crm/contract/addContractDialog";
import BusinessCompetitorList from "@/views/crm/business/businessCompetitorList";
import BusinessPlanList from "@/views/crm/business/businessPlanList";
import BusinessStage from "@/views/crm/business/businessStage";
import BusinessStageChangeDialog from "@/views/crm/business/businessStageChangeDialog";
import BusinessChangedStage from "@/views/crm/business/businessChangedStage"
import ContractList from "@/views/crm/contract/contractList";
import QuoteCalculation from "@/views/crm/quote/index";
import {
  businessNameCheck,
  businessStageList,
  queryBusinessDetail,
  queryBusinessSwot,
  updateBusiness,
  updateBusinessStatus,
  updateBusinessSwot
} from "@/api/crm/business";
import { listQuotes } from "@/api/crm/quote";
import UserAvatar from '@/views/system/user/userAvatar'
import { amountFormat, transferCascaderOptionsForProvince } from '@/utils/index'
import { queryContactByCustomerId } from '@/api/crm/contact'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {mapState} from 'vuex'
import {listAllLevelArea} from '@/api/crm/area'
import {queryProductTypeList2} from "@/api/crm/contract";
import {changeStatus} from "@/api/crm/focus";
import customerSelect from "@/views/crm/components/customerSelect";
import GroupMember from "@/views/crm/groupMember"

export default {
  name: "BusinessDetail",
  data() {
    return {
      amountFormat,
      // 遮罩层
      loading: true,
      detail: {},
      swot: {},
      activeName: "followPlan",
      followPlanActiveName: 'follow',
      editModel: false,
      editSwotModel: false,
      contactCount: 0,
      contractCount: 0,
      quoteCount: 0,
      quoteLoading: false,
      quoteList: [],
      sourceCustomerList: [],
      yzCustomerList: [],
      areaOptions: [],
      businessSourceContactList: [],
      businessLevelOptions: [],
      businessScaleOptions: [],
      businessSourceOptions: [],
      requirementOptions: [],
      projectTypeOptions: [],
      updateData: {
        id: null,
        remark: "",
        customerId: null,
        businessSourceCustomerId: null,
        businessSourceContactId: null,
        projectOwnerCustomerId: null,
        businessLevel: null,
        businessScale: null,
        businessSource: null,
        requirements: [],
        area: [],
        address: null,
        projectType: null,
        businessName: null,
        estimateDealAmount: undefined,
        estimateDealDate: null
      },
      updateSwotData: {
        id: null,
        strengths: "",
        weaknesses: "",
        opportunities: "",
        threats: "",
        businessId: null,
      },
      updateRules: {
        businessName: [
          {required: true, validator: this.checkBusiness, trigger: 'change'},
          {max: 32, message: '长度过长', trigger: 'change'}
        ],
        estimateDealAmount: [
          {required: true, type:'number', message: '请输入预计成交金额', trigger: 'blur'}
        ],
        businessLevel: [
          {required: true, message: '请选择商机级别', trigger: 'change'}
        ],
        businessScale: [
          {required: true, message: '请选择商机规模', trigger: 'change'}
        ],
        businessSource: [
          {required: true, message: '请选择商机来源', trigger: 'change'}
        ],
        requirements: [
          {required: true, message: '请选择采购需求', trigger: 'change'}
        ],
        projectType: [
          {required: true, message: '请选择项目类型', trigger: 'change'}
        ],
        estimateDealDate: [
          {required: true, message: '请选择预计成交时间', trigger: 'change'}
        ]
      },
      updateSwotRules: {
        strengths: [
          {required: true, message: '请输入优势', trigger: 'change'},
          {max: 1000, message: '不能超过1000个字符', trigger: 'change'}
        ],
        weaknesses: [
          {required: true, message: '请输入劣势', trigger: 'change'},
          {max: 1000, message: '不能超过1000个字符', trigger: 'change'}
        ],
        opportunities: [
          {max: 1000, message: '不能超过1000个字符', trigger: 'change'}
        ],
        threats: [
          {max: 1000, message: '不能超过1000个字符', trigger: 'change'}
        ]
      },
      closeBusinessVisible: false,
      closeBusinessModel: {
        businessId: null,
        operateType: null,
        closeReason: '',
        closeDesc: ''
      },
      closeReasonOptions: [
        {name: '输单'},
        {name: '无效'}
      ],
      closeBusinessFormRules: {
        closeReason: [
          {required: true, message: '请选择关闭原因', trigger: 'change'}
        ],
        closeDesc: [
          {required: true, message: '请输入关闭说明', trigger: 'change'}
        ],
      },
      closeReasonVisible: false,
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId,
    })
  },
  components: {
    FollowList,
    FollowAdd,
    WorkPlan,
    OperateLogList,
    AssignDialog,
    AddBusinessContactDialog,
    AddBusinessCompetitorDialog,
    AddBusinessPlanDialog,
    BusinessContactList,
    BusinessPlanList,
    BusinessCompetitorList,
    AddContractDialog,
    BusinessStage,
    BusinessStageChangeDialog, // 变更
    BusinessChangedStage,
    ContractList,
    QuoteCalculation,
    UserAvatar,
    Treeselect,
    customerSelect,
    GroupMember
  },
  created() {
    if (this.$route.params.id) {
      this.queryDetail()
      this.querySwot()
      this.queryBusinessQuoteList()
    } else {
      this.msgError("无效的商机");
    }
    this.getDicts("business_level").then(response => {
      this.businessLevelOptions = response.data;
    });
    this.getDicts("business_scale").then(response => {
      this.businessScaleOptions = response.data;
    });
    this.getDicts("common_source").then(response => {
      this.businessSourceOptions = response.data;
    });
    queryProductTypeList2({}).then(response => {
      this.requirementOptions = response.data || [];
    })
    this.getDicts("project_type").then(response => {
      this.projectTypeOptions = response.data;
    });
    this.getTreeselect()
    listAllLevelArea({ level: 3 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
  },
  watch: {
    editModel (val) {
      if (!val) {
        this.resetForm("updateForm");
      }
    }
  },
  methods: {
    handleBusinessApprove() {
      if (this.$refs.businessChangedStageRef) {
        this.$refs.businessChangedStageRef.handleApprove()
      }
    },
    clearForm () {
      this.resetForm('addGroupMemberForm')
      this.addGroupMemberVisible = false
    },
    handleTabClick (tab) {
      if (tab.name === 'contact') {
        this.$refs.businessContactListRef.queryList()
      } else if (tab.name === 'contract') {
        this.queryBusinessQuoteList()
        if (this.$refs.contractListRef) {
          this.$refs.contractListRef.queryList()
        }
      } else if (tab.name === 'competitor') {
        this.$refs.businessCompetitorListRef.queryList()
      } else if (tab.name === 'plan') {
        this.$refs.businessPlanListRef.queryList()
      }
    },
    refreshContactAndLog() {
      this.refreshOperateLogList();
      this.$refs.businessContactListRef.queryList()
      this.queryBusinessStageList()
    },
    refreshCompetitorAndLog() {
      this.refreshOperateLogList();
      this.$refs.businessCompetitorListRef.queryList()
    },
    refreshPlanAndLog() {
      this.refreshOperateLogList();
      this.$refs.businessPlanListRef.queryList()
    },
    refreshContractAndLog() {
      this.refreshOperateLogList();
      if (this.$refs.contractListRef) {
        this.$refs.contractListRef.queryList()
      }
    },
    refreshQuoteAndLog() {
      this.queryBusinessQuoteList()
      this.refreshOperateLogList()
    },
    refreshDetailAndLog() {
      this.queryDetail()
      this.querySwot()
      this.refreshOperateLogList();
    },
    refreshDetailMemberAndLog() {
      this.queryDetail()
      this.refreshOperateLogList();
    },
    queryDetail () {
      queryBusinessDetail({id:this.$route.params.id}).then(response => {
        if (response.data) {
          this.detail = response.data
        } else {
          this.msgError("查询不到此商机");
        }
      }).catch(error => {
        this.detail = {}
      })
    },
    queryBusinessStageList () {
      businessStageList({businessId:this.$route.params.id}).then(response => {
        this.detail.businessStageDetailListVos = response.data
        this.$refs.businessStageRef.init(this.detail)
      })
    },
    querySwot () {
      queryBusinessSwot({id:this.$route.params.id}).then(response => {
        if (response.data) {
          this.swot = response.data
        }
      }).catch(error => {
        this.swot = {}
      })
    },
    queryBusinessQuoteList() {
      const businessId = this.detail.id || this.$route.params.id
      if (!businessId) {
        this.quoteList = []
        this.quoteCount = 0
        return
      }
      this.quoteLoading = true
      listQuotes({ businessId }).then(response => {
        this.quoteList = (response && response.data) || []
        this.quoteCount = this.quoteList.length
      }).catch(() => {
        this.quoteList = []
        this.quoteCount = 0
      }).finally(() => {
        this.quoteLoading = false
      })
    },
    checkBusiness (rule, value, callback) {
      // 必填
      if (!value) {
        callback(new Error("请输入商机名称"))
      } else if (value === this.detail.businessName) {
        callback()
      } else {
        businessNameCheck(
          {
            currentBusinessId: this.detail.id,
            businessName: value,
            customerId: this.detail.customerId
          }
        ).then( response => {
          if (response.data && response.data.id) {
            callback(new Error("商机名称已存在，请重新输入"))
          } else {
            callback()
          }
        }).catch(error => {
          callback()
        })
      }
    },
    handleAfterFollowAdd () {
      this.$refs.followListRef.refresh()
      this.queryDetail()
    },
    refreshOperateLogList () {
      this.$refs.operateLogListRef.refresh()
    },
    businessStageChange () {
      this.refreshDetailAndLog();
      this.$refs.contractListRef.queryList()
      this.$refs.businessContactListRef.queryList()
    },
    handleAfterContactQuery (contactList) {
      this.contactCount = contactList.length;
    },
    handleAfterContractQuery (contactList) {
      this.contractCount = contactList.length;
    },
    handleAfterContactChange () {
      this.refreshContactAndLog();
    },
    handleEdit () {
      this.updateData.customerId = this.detail.customerId
      this.updateData.businessLevel = this.detail.businessLevel
      this.updateData.businessSource = this.detail.businessSource
      this.updateData.businessScale = this.detail.businessScale
      this.updateData.businessSourceCustomerId = this.detail.businessSourceCustomerId
      this.updateData.projectOwnerCustomerId = this.detail.projectOwnerCustomerId
      this.updateData.businessSourceContactId = this.detail.businessSourceContactId
      this.sourceCustomerList = [{
        id: this.detail.businessSourceCustomerId,
        customerName: this.detail.businessSourceCustomerName
      }]
      this.yzCustomerList = [{
        id: this.detail.projectOwnerCustomerId,
        customerName: this.detail.projectOwnerCustomerName
      }]
      this.updateData.requirements = this.detail.requirements
      this.updateData.projectType = this.detail.projectType
      this.updateData.id = this.detail.id
      this.updateData.area = this.detail.area
      this.updateData.address = this.detail.address
      this.updateData.remark = this.detail.remark
      this.updateData.businessName = this.detail.businessName
      this.updateData.estimateDealAmount = this.detail.estimateDealAmount
      this.updateData.estimateDealDate = this.detail.estimateDealDate
      let area = []
      if (this.detail.provinceCode) {
        area.push(this.detail.provinceCode)
      }
      if (this.detail.cityCode) {
        area.push(this.detail.cityCode)
      }
      if (this.detail.regionCode) {
        area.push(this.detail.regionCode)
      }
      this.updateData.area = area
      queryContactByCustomerId({customerId: this.updateData.businessSourceCustomerId})
        .then(response => {this.businessSourceContactList = response.data})
      this.editModel = true
    },
    handleSwotEdit () {
      this.updateSwotData.id = this.swot.id
      this.updateSwotData.strengths = this.swot.strengths
      this.updateSwotData.weaknesses = this.swot.weaknesses
      this.updateSwotData.opportunities = this.swot.opportunities
      this.updateSwotData.threats = this.swot.threats

      this.editSwotModel = true
    },
    businessSourceCustomerChange() {
      let param = {
        customerId: this.updateData.businessSourceCustomerId
      }
      this.updateData.businessSourceContactId = null
      queryContactByCustomerId(param).then(response => {
        this.businessSourceContactList = response.data
      }).catch(error => {
      })
    },
    skipCustomerDetail(id) {
      this.$router.push("/crm/customer/detail/" + id);
    },
    skipContactDetail(id) {
      this.$router.push("/crm/contact/detail/" + id);
    },
    handleEditSave () {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          this.updateData.provinceCode = this.updateData.area && this.updateData.area.length > 0 ? this.updateData.area[0] : null
          this.updateData.cityCode = this.updateData.area && this.updateData.area.length > 1 ? this.updateData.area[1] : null
          this.updateData.regionCode = this.updateData.area && this.updateData.area.length > 2 ? this.updateData.area[2] : null
          updateBusiness(this.updateData).then(response => {
            this.refreshDetailAndLog();
            this.editModel = false
            loading.close();
            this.msgSuccess("更新成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    handleSwotEditSave () {
      this.updateSwotData.businessId = this.detail.id
      this.$refs['updateSwotForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          updateBusinessSwot(this.updateSwotData).then(response => {
            this.refreshDetailAndLog();
            this.editSwotModel = false
            loading.close();
            this.msgSuccess("更新成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    /** 详细按钮操作 */
    toCustomerDetail() {
      this.$router.push("/crm/customer/detail/" + this.detail.customerId);
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.singleAssign("business", this.detail.id)
    },
    /** 变更按钮操作 */
    handleChange() {
      this.$refs.businessStageChange.open(this.detail.id)
    },
    /** 新增按钮操作 */
    handleAddBusinessContact() {
      this.$refs.addBusinessContactDialogRef.open(this.detail.id, null);
    },
    /** 新增竞争对手按钮操作 */
    handleAddBusinessCompetitor() {
      this.$refs.addBusinessCompetitorDialogRef.open(this.detail.id, null);
    },
    /** 新增方案按钮操作 */
    handleAddBusinessPlan() {
      this.$refs.addBusinessPlanDialogRef.open(this.detail.id, null);
    },
    /** 新增合同按钮操作 */
    handleAddBusinessContract() {
      this.$refs.addContractDialogRef.open('businessId', this.detail.id, this.detail.businessName, this.detail.customerId, this.detail.customerName, this.detail.managerId);
    },
    /** 从商机生成报价 */
    handleAddBusinessQuote() {
      if (!this.detail.id) {
        return
      }
      this.$refs.quoteCalculationRef.openFromBusiness(this.detail.id)
    },
    handleViewBusinessQuote(row) {
      if (!row || !row.id) {
        return
      }
      this.$refs.quoteCalculationRef.handleEdit(row)
    },
    handleBusinessQuoteSheet(row) {
      if (!row || !row.id) {
        return
      }
      this.$refs.quoteCalculationRef.openQuoteSheet(row.id)
    },
    handleBusinessQuoteContractDraft(row) {
      if (!row || !row.id) {
        return
      }
      this.$refs.quoteCalculationRef.exportContractDraft(row)
    },
    handleBusinessQuoteSealApproval(row) {
      if (!row || !row.id) {
        return
      }
      this.$refs.quoteCalculationRef.openSealApproval(row)
    },
    handleBusinessQuoteApprovalRecord(row) {
      if (!row || !row.id) {
        return
      }
      this.$refs.quoteCalculationRef.openApprovalRecord(row)
    },
    handleBusinessQuoteContract(row) {
      if (!row || !row.id) {
        return
      }
      if (row.contractId) {
        window.open("/crm/contract/detail/" + row.contractId, "_blank")
        return
      }
      this.$refs.quoteCalculationRef.handleCreateContract(row)
    },
    quoteStatusText(value) {
      const map = { 10: '草稿', 20: '待用章', 30: '用章审批中', 40: '用章通过', 50: '已转合同', 90: '已作废' }
      return map[Number(value)] || '草稿'
    },
    quoteStatusTag(value) {
      const map = { 10: 'info', 20: 'warning', 30: 'warning', 40: 'success', 50: '', 90: 'info' }
      return map[Number(value)] || 'info'
    },
    quoteSealStatusText(value) {
      const map = { 0: '未发起', 1: '审批中', 2: '已通过', 3: '已驳回', 4: '已取消' }
      return map[Number(value || 0)] || '未发起'
    },
    quoteSealStatusTag(value) {
      const map = { 0: 'info', 1: 'warning', 2: 'success', 3: 'danger', 4: 'info' }
      return map[Number(value || 0)] || 'info'
    },
    canSubmitBusinessQuoteSealApproval(row) {
      const status = Number(row && row.status)
      const sealStatus = Number((row && row.sealStatus) || 0)
      return !!(row && row.id) && !row.contractId && ![1, 2].includes(sealStatus) && ![50, 90].includes(status)
    },
    quoteRiskText(value) {
      const map = {
        LOW_PRICE: '低价',
        LOW_MARGIN: '低毛利',
        PRICE_PENDING: '待完善',
        NON_STANDARD: '非标'
      }
      const text = String(value || '')
        .split(',')
        .filter(Boolean)
        .map(item => map[item] || item)
        .join('、')
      return text || '无风险'
    },
    quoteMoney(value) {
      if (value === null || value === undefined || value === '') return '-'
      return `¥${Number(value || 0).toFixed(2)}`
    },
    quoteNumberText(value) {
      if (value === null || value === undefined || value === '') return '0.00'
      return Number(value || 0).toFixed(2)
    },
    copyText(text, label = '内容') {
      if (!text) {
        return
      }
      const onSuccess = () => this.$message.success(`${label}已复制`)
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(String(text)).then(onSuccess).catch(() => this.copyTextFallback(text, onSuccess))
        return
      }
      this.copyTextFallback(text, onSuccess)
    },
    copyTextFallback(text, onSuccess) {
      const input = document.createElement('textarea')
      input.value = String(text)
      input.setAttribute('readonly', 'readonly')
      input.style.position = 'fixed'
      input.style.top = '-9999px'
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        onSuccess && onSuccess()
      } finally {
        document.body.removeChild(input)
      }
    },
    // confirmClose () {
    //   this.$refs['closeBusinessForm'].validate((valid) => {
    //     if (valid) {
    //       this.closeBusinessModel.businessId = this.detail.id
    //       this.closeBusinessModel.operateType = 1; // 操作类型 1-关闭 2-恢复
    //       const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
    //       updateBusinessStatus(this.closeBusinessModel).then(response => {
    //         this.msgSuccess("操作成功");
    //         this.refreshDetailAndLog()
    //         this.closeBusinessVisible = false
    //       }).finally(() => {
    //         loading.close()
    //       })
    //     }
    //   })
    // },
    // recoveryStatus () {
    //   this.$confirm('确认恢复商机状态吗？', '提示', {confirmButtonText: '确认'}).then(() => {
    //     this.closeBusinessModel.businessId = this.detail.id
    //     this.closeBusinessModel.operateType = 2; // 操作类型 1-关闭 2-恢复
    //     const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
    //     updateBusinessStatus(this.closeBusinessModel).then(response => {
    //       this.msgSuccess("操作成功");
    //       this.refreshDetailAndLog()
    //       this.closeBusinessVisible = false
    //     }).finally(() => {
    //       loading.close()
    //     })
    //   }).catch(() => {});
    // },
    handleFocus (operateType) {
      let param = {
        targetId: this.detail.id,
        targetType: 'business',
        operateType: operateType // 操作类型 1-关注 2-取消关注
      }
      const loading = this.$loading({lock: true, text: '操作中', spinner: 'el-icon-loading'});
      changeStatus(param).then(response => {
          this.msgSuccess(operateType === 1 ? '关注成功' : '取消关注成功')
          this.queryDetail()
        }
      ).finally(() => {
        loading.close();
      });
    },
    handleAfterWorkPlanAdd () {
      this.refreshOperateLogList();
      this.$refs["followListRef"].refresh()
    },
    handleGroupMemberSuccess(userId) {
      if (this.currentUserId === userId) {
        this.queryDetail()
      }
      this.refreshOperateLogList()
      if (this.$refs.followAddRef) {
        this.$refs.followAddRef.queryAtList()
        this.$refs.workPlanRef.queryAtList()
      }
    },
  }
};
</script>
<style lang='scss' scoped>
  .business-detail {
    .closeFlagInfo {
      cursor: default;
      color: black;
    }
    .group-member-add-btn {
      width: 40px;
      height: 40px;
      text-align: center;
      border-radius: 50%;
      padding: 0 0 0 2px;
      position: absolute;
      top: -12px;
    }

    .group-member {
      width: 120px;
      margin-bottom: 20px;
      height: 40px;

      .avatar {
        float: left;
      }

      .name {
        margin-left: 45px;
        line-height: 50px;
        margin-top: -12px;
      }

      .value {
        width: 75px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }

      .group-member-remove-btn {
        margin-left: -5px;
        cursor: pointer;
        position: absolute;
      }
    }

    .business-quote-no-cell {
      display: inline-flex;
      align-items: center;
      max-width: 100%;
    }

    .business-quote-no-link {
      font-family: Consolas, Monaco, monospace;
      white-space: nowrap;
    }

    .business-quote-no-cell .el-button {
      margin-left: 6px;
      padding: 0;
      font-size: 14px;
      flex: 0 0 auto;
    }
  }
</style>
